export class LogMessageModel {
    public message: any;
    public additional: string[];
    public level: number;
    public timestamp: Date;
    public fileName: string;
    public lineNumber: string;
    public id: number;
}